import { combineReducers } from "@reduxjs/toolkit";

import appReducer from '../feature/application/appSlice';
import dashboardSlice from '../feature/Dashboard/dashboardSlice'
const rootReducer = combineReducers({
    app: appReducer,
    dashboard:dashboardSlice
});

export default rootReducer;